import { MonitoringContext, MonitoringMessageOptions, MonitoringModule } from './monitoring.interface';

export class MonitoringAdapter implements MonitoringModule {
  /**
   * @param modules backends to relay every signal to
   * @param captureGuard optional pre-capture hook; if it returns true the exception is considered
   *   handled (e.g. a chunk-load reload) and is not relayed to any backend
   */
  constructor(
    private readonly modules: MonitoringModule[],
    private readonly captureGuard?: (error: unknown) => boolean
  ) {}

  init(): void {
    this.relay((module) => module.init());
  }

  captureException(error: unknown, context?: MonitoringContext): void {
    if (this.captureGuard?.(error)) {
      return;
    }
    this.relay((module) => module.captureException(error, context));
  }

  captureMessage(message: string, options: MonitoringMessageOptions): void {
    this.relay((module) => module.captureMessage(message, options));
  }

  action(name: string, context?: MonitoringContext): void {
    this.relay((module) => module.action(name, context));
  }

  private relay(fn: (module: MonitoringModule) => void): void {
    for (const module of this.modules) {
      try {
        fn(module);
      } catch (error) {
        console.error('[monitoring] backend threw and was isolated', error);
      }
    }
  }
}
